<template>
  <div>
      <el-cascader
        :options="datas"
        :props="props"
        clearable
        v-model="data"
        :show-all-levels="isShowAllLevels"
      ></el-cascader>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { cascaderOptionsOwnApi } from "@/api/module/partyOrganization/partyOrganization";

export default {
  name: "PartyorgCascader",
  
  mixins: [BaseVue],
  
  props: {
    showAll: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      props: { 
        multiple: false, 
        checkStrictly: true 
      }, // 是否多选
      isShowAllLevels: false,
      data: "",
      datas: [],
      value: "" // 初始的默认选项
    };
  },
  
  methods: {
    updateVal(id) {
      console.log("updateVal : " + id);
      this.value = id;
    },
    
    initData(val) {
      this.data = val;
    },
    
    init() {
      this.value = "";
    },
    
    callApi(data) {
      cascaderOptionsOwnApi()
        .then(response => {
          this.datas = response;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  
  mounted() {
    let data = {
      status: 0
    };
    
    if (this.isRoleinfo.hasPer10011 || 
        this.isRoleinfo.hasPer10013 || 
        this.isAdmin) {
      this.callApi(data);
    }
  },
  
  watch: {
    data: {
      handler() {
        this.$emit("onValueChanged", this.data);
      }
    }
  }
};
</script>


<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>